import { call, put } from 'redux-saga/effects';
import { AUTH_SUCCESS, AUTH_FAILURE, SET_AUTH_LOADING } from '../reducers/auth';
import { doLogin } from '../api/login-service';
import { getFilterOptions, cleanState } from './actions';

export function* authorizeSaga({ payload }) {
  yield put({ type: SET_AUTH_LOADING, payload: true });
  try {
    const user = yield call(doLogin, payload);
    const token = btoa(user.username + ':' + user.password);
    localStorage.setItem('token', token);
    
    yield put({ type: AUTH_SUCCESS, payload: { token, name: user.name } });
    yield put(getFilterOptions());
  } catch (err) {
    yield put(cleanState());
    yield put({ type: AUTH_FAILURE, payload: err });
    localStorage.removeItem('token');
  } finally {
    yield put({ type: SET_AUTH_LOADING, payload: false });
  }
}

export function* unauthorizeSaga() {
  yield put({ type: SET_AUTH_LOADING, payload: true });
  try {
    yield put(cleanState());
    localStorage.removeItem('token');
  } catch (err) {
  } finally {
    yield put({ type: SET_AUTH_LOADING, payload: false });
  }
}



// WEBPACK FOOTER //
// ./src/sagas/auth.js